import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: '[app-table-empty-state]',
  templateUrl: './table-empty-state.component.html',
  styleUrls: ['./table-empty-state.component.css'],
})
export class TableEmptyStateComponent implements OnInit {
  @Input() content: string;
  @Input() cta: string;
  @Input() ctaRouterLink: any;
  @Input() size = '3x';

  constructor(private renderer: Renderer2, private ref: ElementRef) {}

  ngOnInit() {
    this.renderer.addClass(this.ref.nativeElement, 'no-hover');
  }
}
